import * as React from 'react';
import {cloneDeep} from 'lodash';
import {v4 as uuidv4} from 'uuid';
import {Reservation} from '../../../shared/CommonInterfaces';

export interface CustomAttribute {
  name: string;
  value: string;
}

export const blankCustomAttribute = () => {
  return {
    name: '',
    value: ''
  };
};

interface Props {
  updateAttribute(updated);
}

const CustomAttributesInput: React.FC<Props> = ({updateAttribute}) => {
  const [customAttribute, setCustomAttribute] = React.useState<CustomAttribute>(blankCustomAttribute);

  const editAttribute = (field: string, value: string) => {
    const copy = cloneDeep(customAttribute);
    copy[field] = value;
    setCustomAttribute(copy);
    updateAttribute(copy);
  };

  return (
    <React.Fragment>
      <div className="form-field custom-attributes">
        <label>
          Custom Client Attribute
          <br />
          <span className="input-hint">(optional) Custom attributes are passed through by the client</span>
        </label>

        <div className="custom-attributes-text">
          <input
            data-testid="custom-attributes-name"
            className="wave-template-input text-input"
            placeholder="Name"
            onChange={(e) => editAttribute('name', e.target.value)}
          />
          <input
            data-testid="custom-attributes-value"
            className="wave-template-input text-input"
            placeholder="Value"
            onChange={(e) => editAttribute('value', e.target.value)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default CustomAttributesInput;
